// src/components/common/ErrorBoundary.jsx
import { Component } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { captureError } from '@/utils/sentry'
import i18n from '@/i18n'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo)
    captureError(error, { componentStack: errorInfo?.componentStack })
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[300px] p-8 text-center">
          <div className="w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mb-4">
            <AlertTriangle size={28} className="text-red-500" />
          </div>
          <h2 className="text-lg font-bold text-gray-800 mb-1">{i18n.t('common.error')}</h2>
          <p className="text-sm text-gray-500 mb-6 max-w-md">
            {i18n.t('common.errorDescription')}
          </p>
          <button
            onClick={this.handleReset}
            className="inline-flex items-center gap-2 bg-[#0d2757] text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#1a3a6b] transition-colors"
          >
            <RefreshCw size={15} />
            {i18n.t('common.retry')}
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
